<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:showNoticeOrderStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.noticeOrderStatus === 'Y' ? 'success' : 'primary'"
        >
          {{ row.v_noticeOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:showNoticeByName="{ row }">
        <span>{{ row.noticeByName }}</span>
        <br />
        <span>{{ row.noticeTime }}</span>
      </template>
      <template v-slot:showOrderAmount="{ row }">
        <span>{{ row.v_orderAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="openDetailPage(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_export') || '导出'"
            placement="top"
            v-if="allow('E')"
          >
            <i
              class="el-icon-download tool-btn"
              @click="noticeOrderExport(row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    openDetailPage({ orderCode, orderNo }) {
      this.$router.push({
        name: 'plan-noticeInspectionOrder-detail',
        params: { orderCode, orderNo }
      })
    },
    async noticeOrderExport({ noticeOrderCode }) {
      this.loadingOpen()
      const taskName = `notice-order`
      const context = {
        noticeOrderCode: noticeOrderCode,
        type: 'all'
      }
      return await this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success'
            })
            return
          }
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.Description_Failed_to_add_export_task') ||
              '导出任务添加失败'
          )
        })
    }
  }
}
</script>
